import React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../localization';
import * as Maps from '../../store/map';
import Login from '../Login';

class Grid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLogin: false,
        };
    }

    showLoginForm = (e) => {
        this.setState({ showLogin: true });
    };

    hideLogin = () => {
        this.setState({ showLogin: false });
    };

    isLoggedIn = () => {
        return this.props.user.data !== null;
    };

    render() {
        let myAccount = this.isLoggedIn() ? (
            <div className="square ripple" onClick={(e) => this.props.history.push('/my-account')}>
                <div className="square__content">
                    <i className="icon-color icon-my-account lh-0"></i>
                    <div className="square__text">{Translate.myAccount}</div>
                </div>
            </div>
        ) : (
            <div className="square ripple" onClick={this.showLoginForm}>
                <div className="square__content">
                    <i className="icon-color icon-my-account lh-0"></i>
                    <div className="square__text">{Translate.login}</div>
                </div>
            </div>
        );

        let myBets = this.isLoggedIn() ? (
            <div className="square ripple" onClick={(e) => this.props.history.push('/my-bets')}>
                <div className="square__content">
                    <i className="icon-color icon-my-bets lh-0"></i>
                    <div className="square__text">{Translate.myBets}</div>
                </div>
            </div>
        ) : (
            <div className="square ripple disabled">
                <div className="square__content">
                    <i className="icon-color icon-my-bets lh-0"></i>
                    <div className="square__text">{Translate.myBets}</div>
                </div>
            </div>
        );

        return (
            <div className="box-list pl-40 pr-40 clearfix">
                <div className="square ripple" onClick={(e) => this.props.history.push('/prematch')}>
                    <div className="square__content">
                        <i className="icon-color icon-soccer lh-0"></i>
                        <div className="square__text">{Translate.sports}</div>
                    </div>
                </div>

                <div className="square ripple" onClick={(e) => this.props.history.push('/inplay')}>
                    <div className="square__content">
                        <i className="bg-live icon-live lh-0"></i>
                    </div>
                </div>

                <div className="square ripple" onClick={(e) => this.props.history.push('')}>
                    <div className="square__content">
                        <i className="icon-color icon-today lh-0"></i>
                        <div className="square__text">{Translate.today}</div>
                    </div>
                </div>

                <div className="square ripple" onClick={(e) => this.props.history.push('')}>
                    <div className="square__content">
                        <i className="icon-color icon-highlights-1 lh-0"></i>
                        <div className="square__text">{Translate.highlights}</div>
                    </div>
                </div>

                <div className="square ripple" onClick={(e) => this.props.history.push('/')}>
                    <div className="square__content">
                        <i className="icon-color icon-score lh-0"></i>
                        <div className="square__text">{Translate.results}</div>
                    </div>
                </div>

                <div className="square ripple" onClick={(e) => this.props.history.push('/')}>
                    <div className="square__content">
                        <i className="icon-color icon-last-minute lh-0"></i>
                        <div className="square__text">{Translate.lastMinute}</div>
                    </div>
                </div>

                {myAccount}

                <div className="square ripple" onClick={(e) => this.props.history.push('/casino')}>
                    <div className="square__content">
                        <i className="icon-color icon-casino-1 lh-0"></i>
                        <div className="square__text">{Translate.casino}</div>
                    </div>
                </div>

                {myBets}

                {this.state.showLogin ? <Login show={this.state.showLogin} hideLogin={this.hideLogin} /> : ''}
            </div>
        );
    }
}

export default connect(Maps.mapUserStateToProps, Maps.mapUserDispatchToProps)(Grid);
